import script from "./home2.vue?vue&type=script&setup=true&lang=js"
export * from "./home2.vue?vue&type=script&setup=true&lang=js"

import "./home2.vue?vue&type=style&index=0&id=5ecf86ee&lang=less"

const __exports__ = script;

export default __exports__